import { APIClient } from "../api";
import { CommentType } from "../../models/SolicitationComment";
import TextTools from '../../services/TextTools/TextTools';

export default class SolicitationAttachmentService extends APIClient {

    async sendFile(file: any, idSolicitation: number, type: CommentType, userId: number, text?: string) {
        const url = this.endpoint + `/SolicitationAttachment`;
        const fileName = TextTools.treatFile(file);

        const param = {
            idSolicitation: idSolicitation,
            type: type,
            idWork: 0,
        } 
        
        const data = new FormData();
        data.append("file", file, fileName);
        const description_ = text ? text : fileName;        

        return this.api({
            method: 'post',
            url,
            headers: {
                "Description": JSON.stringify(description_),
                "UserId": userId
            },
            data,
            params: param,
        });
    }

    async downloadAttachmentById(attachment: any) {
        const url = this.endpoint + `/SolicitationAttachment/${attachment.id}`;

        this.api({
            method: 'get',
            url,
            responseType: 'arraybuffer',
        })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/octet-stream' }));
                const link = document.createElement('a');
                link.href = url;
                link.target = '_blank';
                const fileName = attachment.originalName;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();
            })
            .catch(error => {

            })
    }

    async downloadAttachment(attachment: any) {
        const url = this.endpoint + `/SolicitationAttachment/${attachment.id}`;

        this.api({
            method: 'get',
            url,
            responseType: 'arraybuffer',
        })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/octet-stream' }));
                const link = document.createElement('a');
                link.href = url;
                link.target = '_blank';
                const fileName = attachment.originalName;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();



                let lowerCaseName = attachment.originalName.toLowerCase();
                let imageType = "";

                if (lowerCaseName.indexOf("png") > -1) {
                    imageType = "image/png";
                }

                if (lowerCaseName.indexOf("jpeg") > -1) {
                    imageType = "image/jpeg";
                }

                if (lowerCaseName.indexOf("jpg") > -1) {
                    imageType = "image/jpeg";
                }

                if (lowerCaseName.indexOf("bmp") > -1) {
                    imageType = "image/bmp";
                }

                if (lowerCaseName.indexOf("gif") > -1) {
                    imageType = "image/gif";
                }

                this.showImage(response, imageType, attachment);
            })
            .catch(error => {

            })
    }

    showImage(data: any, fileType: string, attachment: any) {
        const blob = new Blob([data], { type: fileType });
        attachment.internalName = window.URL.createObjectURL(blob);
    }

    async getItem(attachment: any) {
        const url = this.endpoint + `/SolicitationAttachment/${attachment.id}`;

        return this.api({
            method: 'get',
            url,
            responseType: 'arraybuffer',
        })
            .then(response => {
                return response;
            })
    }
}